module.exports = __webpack_public_path__ + "img/jc.6b4c9933.jpg";